
const typeEnumConst = {
	saleNum: 0,
	customerFlow: 1,
	turnoverRatio: 2,
	associatedPurchaseRate: 5,
};

export const message = {
	/**
	 * Unit
	 */
	'constant_yuan': '＄',                          // 元
	'constant_wan': 'mn',                            // 常量万
	'constant_yi': 'bn',                            // 常量亿
	'constant_day': 'Day',                            // 日
	'constant_week': 'Week',                            // 周
	'constant_month': 'Month',                          // 月
	'constant_month_short': 'Month',                          // 月
	'constant_year': 'Year',                           // 年
	'constant_quarter_short': 'season',                 // 季
	'constant_xiaoshoue': 'Sales',                // 销售额
	'constant_liandailv': 'APR',                // 连带率
	'constant_kedanjia': 'PCT',                // 客单价
	'constant_dingdanshu': 'Order',                // 订单数
	'constant_renxiao': 'SPP',                // 人效
	'constant_pingxiao': 'SPS',                // 坪效
	'constant_keliu': 'Traffic',                    // 客流
	'constant_chengjiaolv': 'Conv.',             // 成交率
	'constant_jiandanjia': 'Avg.U.P.',              // 件单价
	'constant_mubiao': 'Target',                     // 目标
	'constant_quarter': 'Seasonal',                   // 季度
	'constant_week_W': 'W',
	'constant_quarter_Q': 'Q',
	'constant_xiaoshoue_unit': 'Sales',                // 销售额(元)
	'constant_kedanjia_unit': 'PCT',                // 客单价(元/单)
	'constant_chengjiaolv_unit': 'Conv.',             // 成交率(%)
	'constant_keliu_unit': 'Traffic',             // 客流(人)
	'constant_renxiao_unit': 'Sales per person',                // 人效(元/人)
	'constant_pingxiao_unit': 'Sales per square foot',         // 坪效(元/平米)
	'constant_jiandanjia_unit': 'Average Unit Price',       // 件单价(元/件)
	'constant_time': 'Time',                            // 时间
	'constant_tianqi': 'Weather',                         // 天气
	'constant_no_data': 'Empty data',                // 无数据是显示
	'constant_all': 'All',                            // 全部
	'constant_loading': 'Loading...',                // 加载中...
	'constant_cancel': 'Cancel',                      // 取消
	'constant_confirm': 'Confirm',                   // 确定
	'constant_1month': 'Jan',                         // 1月
	'constant_2month': 'Feb',                         // 2月
	'constant_3month': 'Mar',                         // 3月
	'constant_4month': 'Apr',                         // 4月
	'constant_5month': 'May',                         // 5月
	'constant_6month': 'June',                         // 6月
	'constant_7month': 'July',                         // 7月
	'constant_8month': 'Aug',                         // 8月
	'constant_9month': 'Sept',                         // 9月
	'constant_10month': 'Oct',                         // 10月
	'constant_11month': 'Nov',                         // 11月
	'constant_12month': 'Dec',                         // 12月
	'constant_weixuanze': 'No choose',                // 未选择
	'constant_start_time': 'Start time',             // 开始时间
	'constant_end_time': 'End time',                  // 结束时间
	'constant_tishi': 'Warning',                       // 提示
	'constant_week_ri': 'Sun',                       // 星期日
	'constant_week_1': 'Mon',                       // 星期1
	'constant_week_2': 'Tues',                       // 星期2
	'constant_week_3': 'Wed',                       // 星期3
	'constant_week_4': 'Thur',                       // 星期4
	'constant_week_5': 'Fri',                       // 星期5
	'constant_week_6': 'Sat',                       // 星期6
	/**
	 * Homepage
	 */
	'homePage_dateTypeMap': [                       // 首页头部模态框
		{ value: 1, label: 'Today' , bannerLabel: ''},
		{ value: 2, label: 'This week' , bannerLabel: ''},
		{ value: 3, label: 'This month', bannerLabel: '' },
		{ value: 4, label: 'This season' , bannerLabel: ''},
		{ value: 5, label: 'This year' , bannerLabel: ''},
	],
	'homePage_sale_array': [                       // 首页头部模态框
		{ value: 1, label: '' },
		{ value: 2, label: '' },
		{ value: 3, label: '' },
		{ value: 4, label: '' },
		{ value: 5, label: '' },
	],
	'homePage_tabList': [                           // 首页tab列表
		{
			value: typeEnumConst.saleNum,
			label: 'Sales',
			unit: '＄',
		},
		{
			value: typeEnumConst.customerFlow,
			label: 'Traffic',
			unit: 'people',
		},
		{
			value: typeEnumConst.turnoverRatio,
			label: 'Conv.',
			unit: '%',
		},
		{
			value: typeEnumConst.associatedPurchaseRate,
			label: 'APR',
			unit: '',
		},
	],
	'homePage_enterprise_overview': 'Company overview',           // 企业概览按钮
	'homePage_cycle_unset_top': 'Not set',                  // 首页圆环按钮未设置时上面的字
	'homePage_cycle_unset_bottom': 'Target',                  // 首页圆环按钮未设置时下面的字
	'homePage_this_month_sale': 'Sales of this month',               // 本月销售额
	'homePage_this_year_sale': 'Sales of this year',               // 本年销售额
	'homePage_noStoreAlertInfo': 'Dock sales data to understand the business development. You still have {num} stores not connected yet.',         //点击感叹号的弹出字
	'homePage_the_average': 'Average',                       // 平均值
	'homePage_alert_noMessage': 'You have not imported the relevant sales data, you can change to traffic display or contact us for data docking. Please call: ',  // 弹出提示
	'homePage_month_complete': 'Completed',               // 完成情况本月完成
	'homePage_year_complete': 'Completed',               // 完成情况本年完成
	'homePage_yichang_text': '{name} error.   Please call: 400-100-1392',          // 异常显示情况
	'homePage_call_phone': 'Call',                    // 拨打电话
	'homePage_zhengchang_text': 'To the average level: ',           // 正常情况显示
	'homePage_kanban': 'Board',                          // 看板
	'homePage_shaixuan': 'Filter',                        // 筛选
	'homePage_paiming': 'Rank',                          // 排名
	/**
	 * Zone overview
	 */
	'stateMent_title_area': 'Zone overview',                 // 头部标题区域概览
	'stateMent_title_company': 'Company overview',                 // 头部标题企业概览
	'stateMent_data_title': 'Core data',                          // 核心数据title
	'stateMent_data_subtitle': 'Detail',                       // 核心数据subtitle
	'stateMent_indicator_tabList': [                       // 时间tab
		{
			label: 'Today',
			value: 1,
		},
		{
			label: 'This week',
			value: 2,
		},
		{
			label: 'This month',
			value: 3,
		},
	],
	'stateMent_sequential_fell': 'Decrease',              // 环比下降
	'stateMent_sequential_rose': 'Increase',              // 环比增长
	'stateMent_chart_title': 'Traffic and sales',     // 图表分析title
	'stateMent_sales_amount': 'Sales Qty',                 // 销售数量
	'stateMent_number_flow': 'Traffic',                 // 客流数
	'stateMent_target_none': 'Sales target not configured',              // 图标目标未配置提醒
	'stateMent_target_config': 'Set now',               // 立即配置
	'stateMent_title_storerank': 'Monthly ranking',            // 门店月销售排名
	'stateMent_subtitle_storerank': 'Detail',              // 排名详情
	'stateMent_title_alarm': 'Alarm',            // 告警消息
	'stateMent_subtitle_alarm': 'Message list',              // 消息列表
	'stateMent_no_storerank': 'No ranking found',                 // 暂无排名
	'stateMent_no_alarm': 'No alarm found',                  // 暂无告警信息
	'stateMent_find_detail': 'More',                   // 了解详情
	/**
	 * Sales Target
	 */
	'saleTarget_saleTarget_config_title': 'Configure',         // 销售目标配置
	'saleTarget_save_target': 'Save',                // 保存配置
	'saleTarget_name_title': '{name} annual sales target',               // 门店名加时间的title
	'saleTarget_last_year_sale': 'Sales of last year',                // 上年销售额
	'saleTarget_money_units': ["＄", "mn", "bn", "tn"],   // 单位
	'saleTarget_danwangji': 'Low season VS Peak season',                     // 淡旺季权重分配
	'saleTarget_now_target': 'Current：',                  // 当前目标数据
	'saleTarget_target_poor': 'To annual target：',                 // 于年目标相差
	'saleTarget_table_head': ['Season','Target(mn)','Last year (mn)'],   // table的表头
	'saleTarget_area_config': 'Regional distribution',                   //区域权重分配
	'saleTarget_average_btn': 'Auto equally distributed',                   // 自动平均分配
	/**
	 * Store
	 */
	'storeData_today_keliu': 'Traffic today',                         // 今日客流
	'storeData_compare_yesterday': 'Traffic yesterday',                         // 对比昨日
	'storeData_data_analyse': 'Analysis',                         // 数据分析
	'storeData_date_array': ['Yeastday','Last week','Last month','Last season','The day before yesterday','Two weeks ago','Two months ago','Two seasons ago'],     // 客流分析下拉框
	'storeData_mingci': 'Words definition',                              // 名词解释
	'storeData_data_mingci_text': [                            // 数据分析名词解释
		'Traffic: passengers into the store',
		'Sales: sales volume',
		'Order: the number of transaction',
		'Conv.: order/traffic*100%',
		'PCT: sales/order',
		'APR: the number of total sold goods/order*100%',
		'Avg.U.P.: sales/the number of total sold goods',
	],  
	'storeData_month_xiaolv': 'Monthly Store Eff.',                      // 月门店效率                     
	'storeData_month_mingci_text': [                            // 月门店效率名词解释
		'SPP: sales/ the number of store employees',
		'SPS:sales/store area'
	],
	'storeData_title_alarm': 'Alarm',                         // 告警信息
	'storeData_subtitle_alarm': 'Message list',                     // 消息列表
	'storeData_alert_mes': 'Please contact your administrator for more indexes.',
	'storeData_jingweidu': 'LAL',                            // 经纬度
	'storeData_mianji': 'Area',
	'storeData_renyuan': 'Person',                                 
	'storeData_alert_config': 'store {mes} no config',
	/**
	 * Zone data
	 */
	'areaData_select_area': 'Select Zone',
	'areaData_analyse': 'Store',                               // 门店分析
	'areaData_choose_time': 'Select time',                          // 时间选择
	'areaData_jiejiahuodong': 'Holiday/promotion day',                         // 节假日/活动日
	'areaData_huodong': 'Promotion day',                                  // 活动日
	'areaData_huanbi': 'MoM',                                      // 环比
	/**
	 * Sales ranking
	 */
	'saleRank_datetype_list': [                                   // 销售排行头部时间切换
		{value: 1, label: 'Daily ranking'},
    {value: 3, label: 'Monthly ranking'},
    {value: 4, label: 'Seasonal ranking'},
	],
	'saleRank_rank': 'Rank',                                         // 表格头column
	'saleRank_store': 'Store',                                         // 表格头column     =
	/**
	 * Ranking
	 */    
	'rank_title': '{name} Ranking',                                      // 排名title
	'rank_find_detail_btn': 'More',                        // 查看详细排名按钮文字
	/**
	 * Alarm
	 */
	'alarm_all_store': 'All stores',                                  // 全部门店
	'alarm_jibie': 'Class',                                           // 级别
	/**
	 * Load page
	 */
	'loading_wuquanxian': 'You are not authorized yet, please contact the adminisrator',     // 加载页无权限时显示
	/**
	 * Sales of the store
	 */
	'sale_store_detail': 'Homepage',                                  // 门店主页
	'sale_today_title': 'Today',                                // 今日+name组成的title
	'sale_compare_lastday': 'Yesterday',                              // 对比昨日
	'sale_the_month_xiaoshoue': 'Cumulative month sales',                     // 月累计销售额
	'sale_last_month_xiaoshoue': 'Last month',                  // 上月累计销售额
	'sale_qushi': 'Trend',                                       // 趋势
	'sale_pingjun': 'Average value',                                        // 平均水平
	'sale_tongbi': 'YoY',                                             // 同比
	'sale_click_more': 'Click for more',                                // 点击加载更多
	'sale_has_all_mes': 'All data has been loaded',                             // 已加载全部数据
	'sale_jiejiari_compare': 'Holiday comparison',                           // 节假日对比
	'sale_month_no_jiejiari': 'No holiday found',                        // 本月无节假日
	'sale_store_rank': 'No. {name}',                            // 本店排名
	'sale_detail_rank': 'Ranking detail',                                   //详细排名
	'sale_mingci': 'Ranking',                                             // 名次/**
	/*
	*  选择门店
	*/
 'chooseStore_select_store': 'Select Store',
 'chooseStore_cancel': 'cancel',
 'chooseStore_search': 'search',
}